export { default } from "./RatingIcon";
